"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GAME_CLOCK_DURATION = void 0;
// Game clock duration in seconds
exports.GAME_CLOCK_DURATION = 30.0;
